package com.essntl.features.itinerary.ui.itinerary_overview

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.ui.proposalhistory.components.JourneyRowUiState

data class ItineraryOverviewState(
    val getItinerary: State<ItineraryModel> = State(),
    val getAllItineraryService: State<List<ItineraryServiceModel>> = State(),
    val getCurrentProfile: State<ProfileModel> = State(),
) {
    val isLoading
        get() = getItinerary.isLoading ||
            getAllItineraryService.isLoading

    val isFailure
        get() = getItinerary.isFailure ||
            getAllItineraryService.isFailure

    fun toUiState(): List<JourneyRowUiState> =
        getAllItineraryService.data.orEmpty()
            .map {
                JourneyRowUiState(
                    id = it.id,
                    index = 0,
                    startTime = it.startTime,
                    price = it.price,
                    priceCurrencySymbol = it.priceCurrency?.symbol,
                    startDate = it.startDate,
                    service = it.service,
                    isItinerary = true,
                )
            }
}